module.exports = __webpack_public_path__ + "static/img/23.15e50bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/23.jpg
// module id = MtGX
// module chunks = 0